import Vue from 'vue'
import App from './App.vue'
import router from './router';
import common from '@/common/token'
import infiniteScroll from 'vue-infinite-scroll'
import './plugins/element.js'
import 'normalize.css'
import '@/assets/css/bass.css'
import 'element-ui/lib/theme-chalk/display.css';
import FileSaver from 'file-saver';
import Clipboard from 'v-clipboard'
import * as XLSX from 'xlsx';
import store from './store';
import AuthService from '@/common/authService.js';

// 引入富文本编辑器
// import VueQuillEditor from 'vue-quill-editor'
// import 'quill/dist/quill.core.css'
// import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css'

import QuillLikeEditor from '@/components/QuillLikeEditor.vue'


function setRem() {
    // 假设设计稿宽度为750px
    const baseWidth = 1920;
    // 获取屏幕宽度
    const screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
    // 计算并设置根元素的字体大小
    if (screenWidth > 1200) {
        document.documentElement.style.fontSize = (screenWidth / baseWidth) * 100 + 'px';
    } else {
        const baseWidth = 750;
        document.documentElement.style.fontSize = (screenWidth / baseWidth) * 16 + 'px';
    }

}
// 初始化设置
setRem();
// 监听屏幕宽度变化重新设置根字体大小
window.onresize = function() {
    setRem();
};

// ========== 将认证服务方法注册为 Vue 全局原型方法 ==========
// 这样在任何组件中都可以通过 this.$saveLoginInfo() 等方式调用
Vue.config.productionTip = false
Vue.prototype.$api = common
Vue.prototype.$FileSaver = FileSaver
Vue.prototype.$XLSX = XLSX
Vue.prototype.$saveLoginInfo = AuthService.saveLoginInfo;
Vue.prototype.$getLoginInfo = AuthService.getLoginInfo;
Vue.prototype.$removeLoginInfo = AuthService.removeLoginInfo;
Vue.prototype.$isLoginValid = AuthService.isLoginValid;
Vue.use(infiniteScroll)
Vue.use(Clipboard)

Vue.prototype.$clipboard = function(text) {
  // 空文本直接返回，不执行复制
  if (!text || text.trim() === '') {
    return false
  }
  // 创建临时输入框复制
  const tempInput = document.createElement('input')
  tempInput.value = text
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
  return true
}
    // Vue.use(VueQuillEditor)
    // ========== 注册结束 ==========

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')